<template>
  <div class="vcita-button-with-badge">
    <v-badge
      v-if="showBadge"
      data-testid="button-with-badge"
      overlap
      :color="bdgBackgroundColor"
      :icon="bdgIcon"
      :content="bdgText" >

      <v-btn
        v-bind="$attrs"
        v-on="$listeners"
        fab
        :color="btnBackgroundColor">
        {{ btnText }}
        <v-icon data-testid="button-with-badge-icon" :color="btnColor" :class="btnIcon" />
      </v-btn>
    </v-badge>
    <v-btn
      v-else
      data-testid="button-without-badge"
      v-bind="$attrs"
      v-on="$listeners"
      fab
      :color="btnBackgroundColor">
      {{ btnText }}
      <v-icon data-testid="button-without-badge-icon" :color="btnColor" :class="btnIcon" />
    </v-btn>
  </div>

</template>


<script>

export default {
  name: 'VcitaButtonWithBadge',
  props:{
    showBadge: {
      type: Boolean,
      required: true
    },
    btnBackgroundColor: {
      type: String,
      required: false
    },
    btnText: {
      type: String,
      required: false
    },
    btnIcon: {
      type: String,
      required: false
    },
    btnColor: {
      type: String,
      required: false
    },
    bdgBackgroundColor: {
      type: String,
      required: false
    },
    bdgText: {
      type: String,
      required: false
    },
    bdgIcon: {
      type: String,
      required: false
    },
    bdgColor: {
      type: String,
      required: false
    },
  },
}
</script>

<style lang="scss">
.vcita-button-with-badge {
  .v-btn {
    height: 40px;
    width: 40px;

    .v-icon {
      font-size: 14px;
    }
  }
}
</style>
